import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

import { AuthService } from '../auth.service';
import { User } from '../../shared/models/user';
import { isPasswordValid } from '../../shared/validators/password';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  token: string;
  passwordError = false;
  password1Error = false;


  qpListener = null
  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.qpListener = this.route.queryParams.subscribe((queryParams: Params) => {
      this.token = queryParams['token'];
    });
  }

  ngOnDestroy(): void {
    this.qpListener.unsubscribe()
  }

  onkeyPassword(event, form) {
    this.passwordError = !isPasswordValid(form.value.password);
  }

  onkeyPassword1(event, form) {
    this.password1Error = !(form.value.password === form.value.password1) && !(form.value.password1.length === 0);
  }

  onInvalid(form: NgForm) {
    return !(form.value.password && form.value.password1 && form.value.password !== '' && form.value.password !== '' && form.value.password === form.value.password1 && isPasswordValid(form.value.password));
  }

  onSend(form: NgForm) {
    const router = this.router;
    this.authService.resetUser(this.token, form.value.password)
      .subscribe(
        (response: any) => {
          if (response && response.success === false) {
            const message = response.same
              ? 'Your new password must be different from your current password.'
              : 'There was a problem resetting your password. Please try again.';
            swal('Oops...', message, 'error');
            return;
          }

          swal({
            title: 'Your password has been changed.',
            text: 'You have successfully created a new password. You are now ready to login to your account.',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
            customClass: 'custom-swal2-hook'
          }).then(
            function () {
              router.navigate(['/signin']);
            },
          )
        },
        (error) => swal('Oops...', error, 'error').then(
          function () {
            router.navigate(['/signin']);
          },
        )
      )

    return false;
  }

  onKeyDownFunction(event, f) {
    if (event.keyCode == 13) {
      return this.onSend(f);
    }
  }
}
